<template>
  <div>
    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="local.bankruptcy.subRequests.requestDetails"
          :value.sync="rootFormModel.requestData"
          :disabled="viewMode || !requiredData.isValidForEdit"
          validates="max:10000|allowed_special_character|required"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="rootFormModel.replyOnSpecificQuestion"
          :items="yesNoOptions"
          item-value="id"
          item-text="name"
          :label="local.bankruptcy.subRequests.isObjectionToTrusteeDecision"
          :disabled="viewMode || !requiredData.isValidForEdit"
          validates="required"
          class="radio-button"
        ></naj-input>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('BankruptcyModule');
const { mapState: mapGlobalState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'BankruptcyObjectionToProcedureOrDecisionRequest',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    rootFormModel: {
      type: Object,
      default: () => ({}),
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    ...mapLUTState(['yesNoOptions']),
  },
  watch: {},
  mounted() {},
  methods: { ...mapGlobalActions(['getUserInfo']) },
};
</script>

<style lang="scss" scoped>
::v-deep .radio-button {
  .v-input--radio-group {
    .radio-button-option {
      background: none;
      border-top: 0px solid #fff;
      border-bottom: 0px solid #fff;
      &:first-child {
        border-right: 0px solid #fff;
      }
      &:last-child {
        border-left: 0px solid #fff;
      }
    }
  }
}
</style>
